// Story 11.4 — Mutation para `POST /bots/:id/rollback`.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { deploymentsApi, type RollbackInput } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

export function useRollbackBot(botId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RollbackInput) => deploymentsApi.rollback(botId, input),
    onSuccess: ({ toDeployment }) => {
      toast.success(`Rollback a ${toDeployment.version} aplicado.`);
      void qc.invalidateQueries({ queryKey: queryKeys.bot(botId) });
      void qc.invalidateQueries({ queryKey: queryKeys.deployments(botId) });
      void qc.invalidateQueries({ queryKey: queryKeys.bots() });
      // P-444: misma lógica que deploy — el rollback cambia el config activo.
      void qc.invalidateQueries({ queryKey: ['bots', botId, 'analytics'] });
      void qc.invalidateQueries({ queryKey: ['bots', botId, 'conversations'] });
    },
    onError: (err) => {
      toast.error(`Rollback falló: ${(err as Error).message}`);
    },
  });
}
